/** Colours per execution status, shared by every list, picker and detail view. */
export const STATUS_DOT: Record<string, string> = {
  Queued: 'bg-muted-foreground/50',
  Running: 'bg-primary',
  Completed: 'bg-success',
  Failed: 'bg-destructive',
  Retried: 'bg-warning',
  Skipped: 'bg-tone-violet',
};

export const STATUS_TEXT: Record<string, string> = {
  Queued: 'text-muted-foreground',
  Running: 'text-primary',
  Completed: 'text-success',
  Failed: 'text-destructive',
  Retried: 'text-warning',
  Skipped: 'text-tone-violet',
};

export const STATUS_BADGE: Record<string, string> = {
  Queued: 'bg-muted text-muted-foreground',
  Running: 'bg-primary/10 text-primary',
  Completed: 'bg-success/10 text-success',
  Failed: 'bg-destructive/10 text-destructive',
  Retried: 'bg-warning/15 text-warning',
  Skipped: 'bg-tone-violet/10 text-tone-violet',
};
